import React from 'react';
import { sistemaTotalRows } from '../data/comparaciones';
import { Emoji } from './Emoji';
export function SistemaTotal() {
  return <section className="w-full bg-forest-800 py-14 sm:py-16" data-id="element-208" data-mp="n82s2e84td16">
      <div className="mx-auto w-full max-w-[680px] px-4 text-center sm:px-6 lg:max-w-[980px]" data-id="element-209" data-mp="10yfuy26621jn">
        <p className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-lime-400 sm:text-sm" data-id="element-210" data-mp="w6o3zqj3ltsz">
          <Emoji symbol="🕊️" data-id="element-211" data-mp="15wzlkfvpg1ic" />
          Solo en Mega Pack + Sistema Total
        </p>
        <h2 className="mt-3 font-display text-[clamp(1.5rem,6vw,2.25rem)] font-extrabold leading-[1.08] tracking-tight text-cream" data-id="element-212" data-mp="15z3q901fh4jo">
          ¿Qué agrega el Sistema Total?
        </h2>

        <ul className="mt-9 grid gap-4 text-left lg:grid-cols-2" data-id="element-213" data-mp="1fvyij173y8pi">
          {sistemaTotalRows.map(row => <li key={row.situation} className="flex flex-col overflow-hidden rounded-2xl border border-line bg-pistacho" data-id="element-214" data-mp="3lq82j6zepukr">
              <p className="bg-forest-900 px-4 py-4 font-display text-[14px] font-bold text-cream sm:px-5 sm:text-[15px]" data-id="element-215" data-mp="2t19de43kp7w">
                {row.situation}
              </p>
              <div className="flex items-start gap-3 border-b border-line px-4 py-4 sm:px-5" data-id="element-216" data-mp="cpe2a9rtiz1l">
                <Emoji symbol="❌" className="mt-0.5" data-id="element-217" data-mp="hh4i2v9iyf0e" />
                <span className="min-w-0 text-[14px] text-forest-700 sm:text-[15px]" data-id="element-218" data-mp="hhxjdgppscb5">
                  <span className="font-semibold text-clay" data-id="element-219" data-mp="mf5y17bnly7n">
                    Sin Sistema Total:{' '}
                  </span>
                  {row.without}
                </span>
              </div>
              <div className="flex items-start gap-3 px-4 py-4 sm:px-5" data-id="element-220" data-mp="vh6vo5asum9u">
                <Emoji symbol="✅" className="mt-0.5" data-id="element-221" data-mp="10efgyer8v6fb" />
                <span className="min-w-0 text-[14px] font-medium text-forest-900 sm:text-[15px]" data-id="element-222" data-mp="2x7qpjh6rzihy">
                  <span className="font-bold text-lime-700" data-id="element-223" data-mp="326tw562elws1">
                    Con Sistema Total:{' '}
                  </span>
                  {row.with}
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}